<template>
  <div class="mb-publish-block">
    <!-- 標題 -->
    <div class="publish-nav">
        <a-icon type="left" @click="back" />
        <span>{{$t("moduleTitles.releaselive")}}</span>
        <div></div>
    </div>
    <!-- 發佈成功 -->
    <div v-if="userInfo.expire_status" class="publish-success-box">
      <TopUpTip></TopUpTip>
    </div>
    <!-- 發佈全景內容 -->
    <div v-else>
      <div class="mb-publish-panorama">
            <!-- 按鈕 -->
            <p style="margin-top: 10px">
                <a-button
                    type="primary"
                    href="javascript:void(0);"
                    @click="addImage"
                    >{{$t("publish.addlive")}}</a-button
                >
            </p>
            <!-- 顯示列表 -->
            <div class="drag-upload">
                <div class="pl-show-img">
                    <div class="item-box" v-for="(item, index) in fileList" :key="index" >
                        <div
                        class="item-img" style="display: flex; margin-bottom: 10px;"
                        ><img :src="item.cover=='' ? '/ssr/static/default.png' : item.cover" style="width:80px;height:80px;margin-right: 15px;"/>
                        <div class="item-info">
                        <div class="info-data" v-html="item.name"></div>
                        <a
                            href="javascript:void(0);"
                            @click.stop="delFile(index,item.id)"
                        >{{$t('actionTitles.delete')}}</a>
                        </div>
                       </div>
                    </div>
               </div>
            </div> 
      </div>
      <!-- 表單 -->
      <div class="mb-publish-info">
        <!-- 直播開始時間 -->
        <van-cell
          :title="$t('publish.starttime.label')"
          :value="info.start_time"
          is-link
          @click="format_time.isShowStartTime = true"
        />
        <van-popup
          v-model="format_time.isShowStartTime"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <van-datetime-picker
            v-model="format_time.start_time"
            type="datetime"
            :title="$t('publish.starttime.placeholder')"
            @confirm="confirmTime(...arguments, 'starttime')"
            @cancel="format_time.isShowStartTime = false"
            :min-date="format_time.min_date"
            :max-date="format_time.max_date"
          />
        </van-popup>
        
        <!-- 直播結束時間 -->
        <van-cell
          :title="$t('publish.endtime.label')"
          :value="info.end_time"
          is-link
          @click="format_time.isShowEndTime = true"
        />
        <van-popup
          v-model="format_time.isShowEndTime"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <van-datetime-picker
            v-model="format_time.end_time"
            type="datetime"
            :title="$t('publish.endtime.placeholder')"
            @confirm="confirmTime(...arguments, 'endtime')"
            @cancel="format_time.isShowEndTime = false"
            :min-date="format_time.min_date"
            :max-date="format_time.max_date"
          />
        </van-popup>
           
        <!-- 作品名稱 -->
        <van-field
          v-model="info.name"
          rows="1"
          :autosize="true"
          :label="$t('publish.workName.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.workName.placeholder')"
          show-word-limit
          input-align="right"
        />
        <!-- 客戶姓名 -->
        <van-field
          v-model="info.customer_name"
          rows="1"
          :autosize="true"
          :label="$t('publish.customerName.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.customerName.placeholder')"
          show-word-limit
          input-align="right"
        />
        <!-- 客戶電話 -->
        <van-field
          v-model="info.customer_phone"
          rows="1"
          :autosize="true"
          :label="$t('publish.customerTel.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.customerTel.placeholder')"
          show-word-limit
          input-align="right"
        />
        <!-- 作品分類 -->
        <van-cell
          :title="$t('publish.workCategory.label')"
          is-link
          :value="info.cate_name"
          @click="showCatePicker"
        />
        <!-- 作品行業 -->
        <van-cell
          :title="$t('publish.industry.label')"
          is-link
          :value="info.industry_name"
          @click="isShowIndustryPicker = true"
        />
        <!-- 作品地區 -->
        <region @updateRegin="updateRegin"></region>
        <!-- 詳細地址 -->
        <van-field
          v-model="info.detail_address"
          rows="1"
          :autosize="true"
          :label="$t('publish.address.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.address.placeholder')"
          show-word-limit
          input-align="right"
        />
        <!-- 保存位置 -->
        <van-cell
          :title="$t('publish.savePath.label')"
          is-link
          :value="info.dir_name"
          @click="treeVisible = true"
        />
        <!-- 是否公開 -->
        <van-cell :title="$t('publish.isPublic')">
          <span slot="default">
            <van-radio-group v-model="info.is_public" direction="horizontal">
              <van-radio :name="1">{{ $t("publish.public") }}</van-radio>
              <van-radio :name="0">{{ $t("publish.pravite") }}</van-radio>
            </van-radio-group>
          </span>
        </van-cell>
        <!-- 作品標籤· -->
        <div class="info-tag-block">
          <p>
            <span class="info-tag-title">{{
              $t("publish.workTag.label")
            }}</span>
          </p>
          <div class="info-tag-list">
            <template v-for="item in tagList">
              <a-tag
                :color="item.isSelected ? 'red' : ''"
                class="tag-btns"
                :closable="item.uid === userInfo.id"
                @close="deleteTag(item, $event)"
                :key="item.id"
                @click="selectTag(item.id)"
                >{{ item.name }}</a-tag
              >
            </template>
            <a-tag class="tag-btns" @click="isShowAddTagModel = true"
              >+{{ $t("publish.tagAdd") }}</a-tag
            >
          </div>
        </div>
        <!-- 作品簡介 -->
        <a-form-model-item has-feedback :label="$t('publish.pDescription')">
          <editor :value="info.brief" @changeEditor="changeEditor"></editor>
        </a-form-model-item>

        <div class="publich-btn">
          <a-button
            class="btns"
            type="danger"
            block
            shape="round"
            :disabled="isUploading"
            @click="publish"
            >{{ $t("publish.publish") }}</a-button
          >
        </div>
        <!-- 素材彈窗 -->
        <HMaterialModal
        :visible="materialVisible"
        ref="material"
        @close="materialVisible = false"
        @handleConfirm="materialConfirm"
      ></HMaterialModal>
      <!-- 作品分類picker -->
        <van-popup
          v-model="isShowCatePicker"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <div class="van-picker__toolbar">
            <button
              type="button"
              class="van-picker__cancel"
              @click="isShowCatePicker = false"
            >
              {{ $t("actionTitles.cancel") }}
            </button>
            <div class="van-ellipsis van-picker__title">
              {{ $t("descriptions.selectWorkCate") }}
            </div>
            <button
              type="button"
              class="van-picker__confirm"
              @click="confirmCate"
            >
              {{ $t("actionTitles.ascertain") }}
            </button>
          </div>
          <a-tree
            style="width: 100%; height: 264px"
            :replaceFields="{
              children: 'children',
              title: 'name',
              key: 'id',
              value: 'id',
            }"
            :tree-data="cateTree"
            :defaultSelectedKeys="[info.cate]"
            default-expand-all
            @select="onSelectCate"
          ></a-tree>
        </van-popup>
        <!-- 作品行業picker -->
        <van-popup
          v-model="isShowIndustryPicker"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <van-picker
            show-toolbar
            :columns="IndustryList"
            :title="$t('descriptions.selectWorkIndustry')"
            @confirm="confirmIndustry"
            @cancel="isShowIndustryPicker = false"
          />
        </van-popup>
        <van-dialog
          v-model="isShowAddTagModel"
          :title="$t('publish.addNewTag.label')"
          show-cancel-button
          @confirm="confirmAddTag"
          @closed="tagModelclosed"
          confirm-button-color="#1989fa"
        >
          <div style="padding: 5px; padding-left: 10%">
            <van-field
              v-model="tagForm.name"
              rows="1"
              :autosize="true"
              type="textarea"
              :placeholder="$t('publish.addNewTag.placeholder')"
            />
          </div>
        </van-dialog>
        <!-- 目錄picker -->
        <van-popup
          v-model="treeVisible"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <div class="van-picker__toolbar">
            <button
              type="button"
              class="van-picker__cancel"
              @click="treeVisible = false"
            >
              {{ $t("actionTitles.cancel") }}
            </button>
            <div class="van-ellipsis van-picker__title">
              {{ $t("descriptions.selectPath") }}
            </div>
            <button type="button" class="van-picker__confirm" @click="confirm">
              {{ $t("actionTitles.ascertain") }}
            </button>
          </div>
          <a-directory-tree
            style="width: 100%; height: 264px"
            :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
            :load-data="onLoadData"
            :tree-data="treeData"
            :selectedKeys="selectedKeys"
            @select="onSelect"
          />
        </van-popup>
      </div>
      

    </div>
  </div>
</template>

<script>
import TopUpTip from "@/components/TopUpTip";
import Region from "@/components/region";
import HMaterialModal from "@/components/HMaterialModal";
import { mapGetters } from "vuex";
import { getTree as getCateTree } from "@/api/cate";
import {deleteTag,getIndustry,getTag,publishVRImg,addTag} from "@/api/publish";
import { getTreeDir } from "@/api/work";
import Editor from "@/components/Editor";
import Vue from 'vue';
import {Cell, CellGroup, Field, Popup, Picker, RadioGroup, Radio, Dialog, DatetimePicker} from "vant";
import {formatDate} from "@/utils/tools";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(DatetimePicker);
export default {
    components: {
    TopUpTip,
    Region,
    HMaterialModal,
    formatDate,
    Editor
  },
    data(){
        return{
            info: {
                name: "",
                customer_name: "",
                customer_phone: "",
                detail_address: "",
                dir_id: 0,
                dir_name: this.$t("moduleTitles.root"),
                cate: null,
                cate_name: "",
                industry: null,
                industry_name: "",
                is_public: 1,
                region: null,
                region_name: "",
                pic_tags: [],
                panolive:[],
                start_time: "",
                end_time: "",  
                brief: "",
            },
            tagForm: {
                type: 0,
                name: "",
            },
            tagList: [],
            fileList: [],
            cateTree: [],
            IndustryList: [],
            selectedKeys: [],
            isShowAddTagModel: false,
            treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
            materialVisible: false,
            isShowCatePicker: false,
            isShowIndustryPicker: false,
            treeVisible: false,
            isUploading: false,
            img_data:[],//圖片
            format_time:{
              start_time: new Date(),
              end_time: new Date(),
              min_date:new Date(),
              max_date:new Date("2099/01/01"),
              isShowStartTime: false,
              isShowEndTime: false,
            },
        }
    },
    computed: {
    ...mapGetters(["userInfo"]),
    },
    created() {
        this.$store.dispatch("getUserInfo"); //更新用戶的配置
        getCateTree().then((res) => {
        this.cateTree = res.data;
        if (this.cateTree.length > 0) {
            // 默認選擇第一個
            this.info.cate = this.cateTree[0].id;
            this.info.cate_name = this.cateTree[0].name;
        }
        });

        getIndustry().then((res) => {
        if (res.code === 1 && res.data.length) {
            this.IndustryList = res.data.map((item) => {
            return item.name;
            });
            this.IndustryOriginalData = res.data;
        }
        });

        this.getTagList();

        // this.getRegoinList({ regoin_id: 0 });
    },
    methods:{
        // 返回按鈕
        back() {
            this.$router.back();
        },
        // 按鈕
        addImage() {
             this.materialVisible = true;
        },
        // 作品分類
        showCatePicker() {
            this.isShowCatePicker = true;
        },
        // 作品地區
        updateRegin(newValue) {
            this.info.region_name = newValue.name;
            this.info.region = newValue.id;
        },
        // 作品簡介
        changeEditor(content) {
          this.info.brief = content;
        },
        // 作品標籤
        deleteTag(item, event) {
            event.preventDefault();
            const { id } = item;
            const key = "tag-delete-key";
            this.$message.loading({
                content: this.$t("message.deleteLoading") + "...",
                key,
            });
            deleteTag({ id })
                .then((res) => {
                this.$message.success({
                    content: this.$t("message.deleteSuccess"),
                    key,
                    duration: 1,
                });
                //本地刪除
                const index = this.tagList.findIndex((item) => item.id === id);
                if (index > 0) {
                    this.$delete(this.tagList, index);
                }
                })
                .catch((err) => {
                this.$message.error({
                    content: this.$t("message.deleteFail"),
                    key,
                    duration: 1,
                });
            });
        },
        selectTag(id) {
            this.tagList.forEach((item) => {
                item.isSelected = item.id === id ? !item.isSelected : item.isSelected;
            });
        },
        // 刪除直播機位
        delFile(index, id) {
          this.fileList.splice(index, 1);
        },
        getTagList() {
          getTag({ type: 0, filter: "all" }).then((res) => {
              if (res.code === 1 && res.data.length) {
              res.data.forEach((item) => {
                  item.isSelected = false;
              });
              if (!this.tagList.length) {
                  this.tagList = res.data;
              } else {
                  let newTag = {};
                  res.data.forEach((item) => {
                  if (!this.tagList.some((value) => value.id === item.id)) {
                      item.isSelected = true;
                      newTag = item;
                  }
                  });
                  this.tagList.push(newTag);
              }
              }
          });
        },
        //點擊選擇分類
        onSelectCate(selectedKeys, info) {
            if (selectedKeys.length > 0) {
                this.tempCateName = info.node.dataRef.name;
                this.tempCateId = selectedKeys[0];
            }
        },
        // 確認分類選擇
        confirmCate() {
            this.info.cate = this.tempCateId;
            this.info.cate_name = this.tempCateName;
            this.tempCateName = "";
            this.tempCateId = "";
            this.isShowCatePicker = false;
        },
        // 作品行業
        confirmIndustry(value, index) {
          this.IndustryOriginalData.find((item) => {
              if (item.name === value) {
              this.info.industry = item.id;
              this.info.industry_name = item.name;
              }
          });
          this.isShowIndustryPicker = false;
        },
        confirmAddTag() {
            if (this.tagForm.name) {
                addTag(this.tagForm)
                .then((res) => {
                    if (res.code === 1) {
                    this.getTagList();
                    this.$message.success(this.$t("publish.addNewTag.message"), 3);
                    }
                })
                .catch((err) => {});
            }
        },
        tagModelclosed() {
            this.tagForm = { type: 0, name: "" };
        },
        // 目錄
        confirm() {
            if (this.selectedKeys.length <= 0) {
                this.$message.warning(this.$t("message.selectPath"));
                return;
            }
            this.info.dir_id = this.selectedKeys[0];
            this.info.dir_name = this.selectedName;
            this.treeVisible = false;
        },
        onSelect(selectedKeys, info) {
            this.selectedKeys = selectedKeys;
            this.selectedName = info.node.dataRef.name;
        },
        onLoadData(treeNode) {
            return new Promise((resolve, reject) => {
                if (treeNode.dataRef.children) {
                resolve();
                return;
                }
                getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
                if (res.code && res.data.length > 0) {
                    treeNode.dataRef.children = res.data;
                } else {
                    treeNode.dataRef.isLeaf = true;
                }
                this.treeData = [...this.treeData];
                resolve();
                });
            });
        },
        // 老的文件上傳完畢後的處理方法
        handlefileList(list) {
            let panolive = [];
            if (list && list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                const item = list[i];
                    panolive.push({
                    id: item.id,
                    name: item.name,
                    cover: item.cover,
                    });
                }
            }
            this.info.panolive = panolive;
        },
         // 素材彈窗
        materialConfirm(list) {
          this.img_data=[{name:list[0].name,cover:list[0].cover,id:list[0].id}]
          let materialList = list.map((item) => {
              if (this.materialVisible) {
              item.name = item.name;
              item.bgImg = item.cover;
              }
              return item;
          });
          let selectedList = [];
          if (this.fileList.length) {
              materialList.forEach((item) => {
              if (
                  !this.fileList.some(
                  (value) => value.id === item.id
                  )
              ) {
                  selectedList.push(item);
              }
              });
          } else {
              selectedList = materialList;
          }
          this.materialVisible = false;
          this.fileList = selectedList;
        },
        // 上傳全景
        publish() {
            this.tagList.forEach((item) => {
                if (item.isSelected) {
                this.info.pic_tags.push(item.id);
                }
            });
            this.handlefileList(this.filesList);
            if (this.info.name === "") {
                this.$message.error(this.$t("publish.workName.message"));
                return;
            }
            if (!this.info.industry) {
                this.$message.error(this.$t("publish.industry.message"));
                return;
            }
            if (!this.info.cate) {
                this.$message.error(this.$t("publish.workCategory.message"));
                return;
            }
            if (!this.info.region) {
                this.$message.error(this.$t("publish.workRegion.message"));
                return;
            }
            if (this.info.pic_tags.length === 0) {
                this.$message.error(this.$t("publish.workTag.message"));
                return;
            }
            if (this.info.customer_name === "") {
                this.$message.error(this.$t("publish.customerName.message"));
                return;
            }
            if (this.info.customer_phone === "") {
                this.$message.error(this.$t("publish.customerTel.message"));
                return;
            }
            if (this.info.detail_address === "") {
                this.$message.error(this.$t("publish.address.message"));
                return;
            }
            if (this.info.dir_id === "") {
                this.$message.error(this.$t("publish.savePath.message"));
                return;
            }

            let isError = false;
           this.info.panolive=this.img_data
            if (this.info.panolive.length) {
                publishVRImg(this.info)
                .then((res) => {
                    this.$router.push({ name: "mbWorkList" });
                })
                .catch((err) => {
                    isError = true;
                });
            } else {
                publishVRImg(this.info)
                .catch((err) => {
                    isError = true;
                });
                setTimeout(() => {
                if (isError) return;
                this.$message.success({
                    content: this.$t("publish.publishSuccess"),
                    key: this.loadingKey,
                    duration: 2,
                });
                this.$router.push({ name: "mbWorkList" });
                }, 1500);
            }
        },
        /*
         * 確認選擇時間（注意：綁定組件自帶的監聽事件傳入額外參數：...arguments, params）
         * @param value:選中的時間，GMT格式
         * @param type: 選中的類型，開始時間、結束時間
        */
        confirmTime(value,type){
          if(type=='starttime'){
            this.info.start_time = formatDate("YYYY-mm-dd HH:MM:SS",value);
            this.format_time.start_time = value;
            this.format_time.isShowStartTime = false;
          }
          if(type=='endtime'){
            this.info.end_time = formatDate("YYYY-mm-dd HH:MM:SS",value);
            this.format_time.end_time = value;
            this.format_time.isShowEndTime = false;
          }
        },
    }

}
</script>

<style  lang="less" scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.drag-upload {
  margin-bottom: 20px;
  margin-top: 24px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.02);
}
.mb-publish-block {
  width: 100vw;
  min-height: 100vh;
  background: #fff;

  .publish-nav {
    width: 100vw;
    padding: 0 5vw;
    height: 50px;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mb-publish-panorama {
    /*margin-top: 52px;*/
    padding: 55px 5vw 0 5vw;
  }
  .info-tag-block {
    // padding: 5px 0 15px;
    padding: 5px 5vw 0 5vw;
    border-bottom: 1px solid #d7d7d7;
    .info-tag-title {
      width: 25%;
    }
    .info-tag-list {
      display: flex;
      flex-wrap: wrap;
      .tag-btns {
        border-radius: 50px;
        margin-bottom: 8px;
        line-height: 28px;
        padding: 0 10px;
      }
    }
  }
  .publich-btn {
    margin: 15px 0;
    padding: 0 5vw 10px 5vw;
    .btns {
      height: 38px;
    }
  }
  .van-radio-group--horizontal {
    justify-content: flex-end !important;
  }
  .van-picker__columns {
    height: 35vh;
  }
  /deep/ .ant-input {
    border: none;
    text-align: right;
  }
  /deep/ .ant-cascader-input.ant-input {
    padding-right: 30px;
  }
  /deep/ .ant-cascader-picker-label {
    padding-right: 30px !important;
  }
  /deep/ .drag-upload .moxie-shim {
    height: 100% !important;
  }
}

.publish-success-box {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  .box-content {
    display: flex;
    flex-wrap: wrap;
    width: 200px;
    justify-content: center;
    h1 {
      width: 100%;
      font-size: 20px;
      color: #333;
      text-align: center;
      margin: 15px 0;
    }
    .edit-btn,
    .publish-btn {
      width: 100%;
      font-size: 14px;
      height: 34px;
    }
  }
  .mb-publish-info {
    padding-bottom: 20px;
  }
}
.pl-show-img{
  display: flex;
  flex-wrap: wrap;
}
  .pl-show-img .item-info .info-data{
    word-wrap:break-word;
    word-break:break-all;
    height: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  }
  .pl-show-img .item-info {

  padding: 8px 10px 0 10px;
  height: 80px;
  width: 100%;
  overflow: hidden;
  }
  .item-box {
  width: 100%;
  min-width: 180px;
  background: #f3f3f3;
  margin: 0 2% 10px 0;
  overflow: hidden;
  display: flex;
}
</style>
